import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-project-health',
  templateUrl: './project-health.component.html',
  styleUrls: ['./project-health.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectHealthComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {

  }

}
